@if (inEditMode) {
	<mat-form-field appStopPropagation class="simAdminSettingsInputFieldUnchanged inTableSettingsFormField" [@zoomInOnEnter] color="accent">
		<mat-label>{{ labelText }}</mat-label>
		@if (usingStringValues) {
			<mat-select [ngModel]="selectedStringValues" (ngModelChange)="handleStringModelChange($event)" multiple>
				@for (value of selectableValues; track value) {
					<mat-option [value]="value">
						{{ value }}
					</mat-option>
				}
			</mat-select>
		}
		@if (!usingStringValues) {
			<mat-select
				[placeholder]="nullValueDisplayOptions?.text"
				[compareWith]="compareWithFunction"
				[ngModel]="selectedStringValues"
				(ngModelChange)="handleStringModelChange($event)"
				multiple
			>
				@if (nullValueDisplayOptions) {
					<mat-option [value]="nullValueDisplayOptions.substituteValue">{{ nullValueDisplayOptions.text }}</mat-option>
				}
				@for (value of selectableValues; track value) {
					<mat-option [value]="value">
						{{ getDisplayValue(value) | translate }}
					</mat-option>
				}
			</mat-select>
		}
	</mat-form-field>
}
@if (!inEditMode) {
	<div [@flyInOut]="load_completed" class="inTableSettingsViewValue">
		<div class="value showDotsOnOverflow wihtoutLineBreak">
			@if (usingStringValues) {
				@for (value of enumValueToString(selectedValue); track value) {
					<span> {{ value }}<br /> </span>
				}
			}
		</div>
	</div>
}
